import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from 'tss-react/mui';
import { useUnassignContactTag } from '../../../sic-lib/api/hooks/useContact';
import { ContactTag } from '../../../sic-lib/types/ContactTag';

interface Props {
    contactId: number;
    tag: ContactTag;
}

export default function TagComponent({ tag, contactId }: Props) {
    const { classes } = useStyles();

    const { mutate: unAssignContactTag, isLoading } = useUnassignContactTag(contactId);

    const handleDelete = async () => {
        unAssignContactTag(tag.tagId);
    };

    return (
        <span className={classes.root}>
            <Chip variant="outlined" size="small" label={tag.tag} onDelete={handleDelete} />
            {isLoading && <CircularProgress size={16} className={classes.progress} />}
        </span>
    );
}

const useStyles = makeStyles()({
    root: {
        position: 'relative',
    },
    progress: {
        position: 'absolute',
        top: '2px',
        right: '4px',
        zIndex: 10,
    },
});
